// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XWWR","questions":"styles_questions__3sHo8","footer":"styles_footer__1LgxO"};